var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26924 3.73333C9.26924 4.95327 8.26683 5.96667 7 5.96667C5.73318 5.96667 4.73077 4.95327 4.73077 3.73333C4.73077 2.5134 5.73318 1.5 7 1.5C8.26683 1.5 9.26924 2.5134 9.26924 3.73333ZM10.7692 3.73333C10.7692 5.7952 9.08169 7.46667 7 7.46667C4.91832 7.46667 3.23077 5.7952 3.23077 3.73333C3.23077 1.67147 4.91832 0 7 0C9.08169 0 10.7692 1.67147 10.7692 3.73333ZM5.46342 10.0333H8.53658C10.6689 10.0333 12.5 11.851 12.5 14.2222C12.5 14.3188 12.4636 14.3929 12.4181 14.4403C12.3735 14.4867 12.33 14.5 12.2927 14.5H1.70732C1.67003 14.5 1.62647 14.4867 1.58194 14.4403C1.5364 14.3929 1.5 14.3188 1.5 14.2222C1.5 11.851 3.33108 10.0333 5.46342 10.0333ZM0 14.2222C0 11.0803 2.44606 8.53334 5.46342 8.53334H8.53658C11.5539 8.53334 14 11.0803 14 14.2222C14 15.2041 13.2356 16 12.2927 16H1.70732C0.764392 16 0 15.2041 0 14.2222Z",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/iconUser.5a15acae.svg";
export { ForwardRef as ReactComponent };